import { render, staticRenderFns } from "./LegalInfoPageForm.vue?vue&type=template&id=28b3951e&"
import script from "./LegalInfoPageForm.vue?vue&type=script&lang=js&"
export * from "./LegalInfoPageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports